module.exports = __webpack_public_path__ + "static/media/4H.cb60aa7c.svg";